import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class BreachService {
    getBreach(email) {
        return axios.get(API_URL + 'breach-checker?email='+email, { headers: authHeader() });
    }
    list() {
        return axios.get(API_URL + 'breach-checker/data', { headers: authHeader() });
    }

    saveBreach(data) {
        return axios.post(API_URL + 'breach-checker', data, { headers: authHeader() });
    }
  
    deleteBreach(id) {
        return axios.delete(API_URL + 'breach-checker-delete/'+id, { headers: authHeader() });
    }
 
}

export default new BreachService();
